<div class="portal--header">
    <h1 class="heading">Logged Out</h1>
</div>

<div class="portal--main">
    <p>You have been logged out.</p>
    <p>
        <a
            href="#top"
            class="text-link focus-element"
            [routerLink]="['/portal']"
            ><span class="focus--content" tabindex="-1">Log back in</span></a
        >
    </p>
</div>
